var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "notfonud" }, [
      _c("h1", [_vm._v("没有找到当前组件，请检查配置")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }